module.exports = __webpack_public_path__ + "img/25.a3b52b34.png";